import Layout from '@/layout/layout'

const featureRouter = {
  path: '/RecallOrder',
  component: Layout,
  redirect: 'noRedirect',
  name: '订单管理',
  children: [
    {
      path: 'index',
      component: () => import('@/views/RecallOrder/index'),
      name: '订单列表',
      meta: { title: '订单列表', noCache: true, fixed: true }
    },
    {
      path: 'Details',
      component: () => import('@/views/RecallOrder/Details'),
      name: '订单详情',
      meta: { title: '订单详情', noCache: true, fixed: true }
    },
    {
      path: '/RecallOrder/spreadOrder/index',
      component: () => import('@/views/RecallOrder/spreadOrder/index'),
      name: '订单管理',
      meta: { title: '差价订单', noCache: true, fixed: true }
    },
    {
      path: '/RecallOrder/Makeuporderstatistics',
      component: () => import('@/views/RecallOrder/Makeuporderstatistics/index'),
      name: '补拍统计',
      meta: { title: '补拍订单统计', noCache: true, fixed: true }
    },
    {
      path: '/RecallOrder/customerList',
      component: () => import('@/views/RecallOrder/customerList/index'),
      name: '客户列表',
      meta: { title: '客户列表', noCache: true, fixed: true }
    },
    {
      path:"evaluate",
      component:()=>import("@/views/RecallOrder/Evaluate/index.vue"),
      name:"估价单",
      meta: {title: "估价单",noCache: true}
    },
    {
      path:"storeReview",
      component:()=>import("@/views/RecallOrder/storeReview/index.vue"),
      name:"差异订单",
      meta: {title: "差异订单",noCache: true}
    },
    {
      path:"process",
      component:()=>import("@/views/RecallOrder/storeReview/process.vue"),
      name:"差异详情",
      meta: {title: "差异详情",noCache: true}
    },
    {
      path: '/RecallOrder/index',
      component: () => import('@/views/RecallOrder/Details'),
      name: '订单管理',
      meta: { title: '差价订单详情', noCache: true, fixed: true }
    },
  ]
}

export default featureRouter
